import React from "react";

import PropTypes from "prop-types";
import '../components/SectionTarjetas.css';

function Card({ imageSource, title, servicios }) {
  return (
    <div className="card text-center bg-dark animate__animated animate__fadeInUp">
      <div className="overflow">
        <img src={imageSource} alt="a wallpaper" className="card-img-top" />
      </div>
      <div className="card-body-tarjetas text-light">
        <h4 className="card-title">{title}</h4>		
		<p className="card-text-tarjetas text-secondary">{servicios}</p>
      </div>
    </div>
  );
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  servicios: PropTypes.string,
  imageSource: PropTypes.string
};

export default Card;
